import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { COLOR_PRESETS } from './constants';

/**
 * Preset color swatches for text-icon backgrounds.
 * Visual behavior matches HomeLauncher ButtonAdminModal.
 *
 * @param {object} props
 * @param {string} props.value - selected hex color
 * @param {(color: string) => void} props.onChange
 * @param {string[]} [props.presets]
 * @param {string} [props.label]
 */
export default function ColorPicker({
  value,
  onChange,
  presets = COLOR_PRESETS,
  label = 'Background color',
}) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 0.5, flexWrap: 'wrap' }}>
        {presets.map((c) => (
          <Box
            key={c}
            onClick={() => onChange?.(c)}
            sx={{
              width: 28,
              height: 28,
              borderRadius: '50%',
              bgcolor: c,
              border: value === c ? '2px solid #1976d2' : '1px solid rgba(0,0,0,0.2)',
              cursor: 'pointer',
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}
